import { createListenerMiddleware, createSlice, isAnyOf } from '@reduxjs/toolkit';
import { setLocalApiKey, setLocalRecentDocs } from './preferenceApi';
// import { RootState } from '../store';

// interface Preference {
//   apiKey: string;
//   selectedDocs: Doc | null;
//   sourceDocs: Doc[] | null;
//   conversations: { name: string; id: string }[] | null;
// }

const initialState = {
    apiKey: 'xxx',
    selectedDocs: {
        name: 'default',
        language: 'default',
        location: 'default',
        version: 'default',
        description: 'default',
        fullName: 'default',
        dat: 'default',
        docLink: 'default',
        model: 'openai_text-embedding-ada-002'
    },
    sourceDocs: null,
    conversationsMindmap: null
};

export const prefMindmapSlice = createSlice({
    name: 'preferenceMindmap',
    initialState,
    reducers: {
        setApiKey: (state, action) => {
            state.apiKey = action.payload;
        },
        setSelectedDocs: (state, action) => {
            state.selectedDocs = action.payload;
        },
        setSourceDocs: (state, action) => {
            state.sourceDocs = action.payload;
        },
        setConversations: (state, action) => {
            state.conversationsMindmap = action.payload;
        }
    }
});

export const { setApiKey, setSelectedDocs, setSourceDocs, setConversations } = prefMindmapSlice.actions;
export default prefMindmapSlice.reducer;

export const prefListenerMiddleware = createListenerMiddleware();
prefListenerMiddleware.startListening({
    matcher: isAnyOf(setApiKey),
    effect: (action, listenerApi) => {
        setLocalApiKey(listenerApi.getState().preferenceMindmap.apiKey);
    }
});

prefListenerMiddleware.startListening({
    matcher: isAnyOf(setSelectedDocs),
    effect: (action, listenerApi) => {
        setLocalRecentDocs(listenerApi.getState().preferenceMindmap.selectedDocs ?? []);
    }
});

export const selectApiKey = (state) => state.preferenceMindmap.apiKey;
export const selectApiKeyStatus = (state) => !!state.preferenceMindmap.apiKey;
export const selectSelectedDocsStatus = (state) => !!state.preferenceMindmap.selectedDocs;
export const selectSourceDocs = (state) => state.preferenceMindmap.sourceDocs;

export const selectSelectedDocs = (state) => state.preferenceMindmap.selectedDocs;
export const selectConversations = (state) => state.preferenceMindmap.conversationsMindmap;
export const selectConversationId = (state) => state.conversationMindmap.conversationId;
